export default class SubsetController {
    constructor($uibModalInstance, $scope, $injector) {
        this.$uibModalInstance = $uibModalInstance;
        this.$scope = $scope;

        this.numberFormatService = $injector.get('numberFormatService');
        this.boot();
    }

    boot() {
        this.subsetValue = '';
        this.item = this.$scope.params.item;
        this.mode = this.$scope.params.mode;

        this.$uibModalInstance.rendered.then(() => {
            this.initJQuery();
        });
    }

    initJQuery(){
        var keyboardPosition = {
            of: $('.keyboard-container'),
            my : 'center top',
            at : 'center top',
            at2: 'center bottom'
        };

        $('.vrkeyboardnum-modal').keyboard({
            layout: 'customnum',
            autoAccept : true,
            position: keyboardPosition,
        });
    }

    confirmSelection() {
        let number = this.numberFormatService.formatStringToNumber(this.subsetValue);
        this.$uibModalInstance.close(number);
    };

    cancel() {
        this.$uibModalInstance.dismiss('cancel');
    };
}